import { SelectOption } from '@/components/common/SelectDropdown';

export const itemTypes: SelectOption[] = [
  {
    value: 'goods',
    label: 'Goods',
  },
  {
    value: 'service',
    label: 'Service',
  },
];

export const getItemTypeLabel = (value: string) => {
  return itemTypes.find((opt) => opt.value === value)?.label || value;
};
